<div class="upsell-buttons">
  <div class="upsell-buttons__container mx-auto p-4">
    <div class="upsell-buttons__row flex flex-col items-center gap-8 justify-center">
      <div class="upsell-buttons__content w-full desktop:w-2/3" [ngClass]="{'w-full' : !showImage }">
        <div class="upsell-buttons__buttons flex flex-col gap-4">
          <button 
            data-qa="cta-yes" 
            class="upsell-buttons__button-yes w-full px-2 py-3 overflow-visible text-center font-extrabold text-white rounded-md transition-transform active:translate-y-0.5"
            [ngClass]="upsellCtaTextButtonsClass"
            (click)="nextPage(true)"  
            data-te="cta-yes" 
            [innerHTML]="buttonYesText"  
            title="YES I WANT THIS SPECIAL ADDED TO MY ORDER">
            YES I WANT THIS SPECIAL ADDED TO MY ORDER
          </button>

          <button 
            data-qa="cta-no" 
            class="upsell-buttons__button-no w-full px-2 py-3.5 overflow-visible text-center font-semibold text-gray-500 rounded-md transition-transform active:translate-y-0.5"
            [ngClass]="{'hidden' : !showbuttonNoText, upsellCtaTextButtonsClass }" 
            (click)="nextPage(false)" 
            [innerHTML]="buttonNoText" 
            data-te="cta-no">
          </button>
          
          <p 
            class="upsell-buttons__description text-lg text-gray-800"
            [ngClass]="{'hidden' : !showDescription }">
            {{ description }}
          </p>
        </div>
      </div>
      
      <div 
        class="upsell-buttons__image w-full desktop:w-1/3 text-center" 
        [ngClass]="{'hidden' : !showImage }">
        <img class="mx-auto" src="{{ image }}" alt="{{ imageAlt }}">
      </div>
    </div>
  </div>
</div>
